function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, InputNumber, Space, message, Alert } from "antd";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var NewCompany = function NewCompany(_ref) {
  var handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      formError = _useState4[0],
      setFormError = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      formSuccess = _useState6[0],
      setFormSuccess = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      insurers = _useState8[0],
      setInsurers = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      rateDisabled = _useState10[0],
      setRateDisabled = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      insDisabled = _useState12[0],
      setInsDisabled = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      insuranceId = _useState14[0],
      setInsuranceId = _useState14[1];

  var _useState15 = useState(0),
      _useState16 = _slicedToArray(_useState15, 2),
      rate = _useState16[0],
      setRate = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      isDataChanged = _useState18[0],
      setIsDataChanged = _useState18[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onTypeChange = function onTypeChange(v) {
    setRateDisabled(v == 1);
    setInsDisabled(v == 1);
  };

  var onInsChange = function onInsChange(v) {
    setInsuranceId(v);
  };

  var onRateChange = function onRateChange(v) {
    if (v != null) setRate(v);
  };

  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('label', values.label);
    formData.append('address', values.address);
    formData.append('telephone', values.telephone);
    formData.append('insurance_id', values.insurance_id);
    formData.append('rate', rate);
    formData.append('commercial_rate', values.commercial_rate);
    formData.append('tax_rate', values.tax_rate);
    formData.append("type", values.type);
    formData.append("user_id", Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addcompany', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      commercial_rate: 0,
      tax_rate: 0,
      type: 0
    });
    setIsDataChanged(false);
    setIsFormLoading(true);
    axios.get(Common.baseApiUrl + 'geticompanylist/' + Common.currentUser.id).then(function (response) {
      setIsFormLoading(false);

      if (response.data.status == 200 && response.data.iclist.length > 0) {
        setInsurers(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: "Aucune",
            value: 0
          }]);
        });
        response.data.iclist.forEach(function (ic) {
          setInsurers(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: ic.label,
              value: ic.id
            }]);
          });
        });
        form.setFieldsValue({
          insurance_id: insurers,
          rate: null,
          address: '',
          telephone: '',
          type: 0,
          commercial_rate: 0,
          tax_rate: 0
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "type",
        label: "Cat\xE9gorie",
        rules: [{
          required: true,
          message: "Veuillez choisir un type"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          onChange: onTypeChange,
          defaultValue: [0],
          options: [{
            label: "SOCIETE",
            value: 0
          }, {
            label: "ASSURANCE",
            value: 1
          }],
          placeholder: "Choisir un type"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "Nom",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "address",
        label: "Adresse",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "telephone",
        label: "T\xE9l\xE9phone",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "insurance_id",
          onChange: onInsChange,
          label: "Assurance",
          children: /*#__PURE__*/_jsx(Select, {
            defaultActiveFirstOption: true,
            disabled: insDisabled,
            options: insurers,
            placeholder: "Choisir l'assureur"
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "rate",
          label: "Taux (%)",
          children: /*#__PURE__*/_jsx(InputNumber, {
            onChange: onRateChange,
            disabled: rateDisabled
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "commercial_rate",
        label: "Taux commercial",
        rules: [{
          required: true,
          message: "Veuillez choisir un taux"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          defaultValue: [0],
          options: [{
            label: "0 %",
            value: 0
          }, {
            label: "-5 %",
            value: -5
          }, {
            label: "-10 %",
            value: -10
          }, {
            label: "-20 %",
            value: -20
          }, {
            label: "-30 %",
            value: -30
          }, {
            label: "-40 %",
            value: -40
          }, {
            label: "-50 %",
            value: -50
          }, {
            label: "-60 %",
            value: -60
          }, {
            label: "-70 %",
            value: -70
          }, {
            label: "-80 %",
            value: -80
          }, {
            label: "-90 %",
            value: -90
          }, {
            label: "+10 %",
            value: 10
          }, {
            label: "+50 %",
            value: 50
          }, {
            label: "+100 %",
            value: 100
          }, {
            label: "+150 %",
            value: 150
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "tax_rate",
        label: "Taxe retenue",
        rules: [{
          required: true,
          message: "Taxes & Retenue"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          defaultValue: [0],
          options: [{
            label: "0 %",
            value: 0
          }, {
            label: "5 %",
            value: 5
          }, {
            label: "10 %",
            value: 10
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          loading: isFormLoading,
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "CREER"
          })
        })
      })]
    })]
  });
};

export default NewCompany;